// extracted by mini-css-extract-plugin
export default {"primaryText":"PaymentSuccess_primaryText__jI2kR","scopeData":"PaymentSuccess_scopeData__yxHGJ","selectedCardBorder":"PaymentSuccess_selectedCardBorder__OGgKT"};